import React, { useCallback, useEffect, useState } from 'react';

import ConfirmChangesModal from 'adapter/in/common/components/ConfirmActionModal/ConfirmActionModal';

import useWidget from 'adapter/in/dashboards/context/Widget/data';
import i18n from 'asset/translation';
import { useCase } from 'adapter/in/common/hooks/useCase';
import { dispatchWidgetsView } from 'adapter/in/dashboards/context/Widgets/view';
import { DeleteDashboardAnalysisCriteriaBuilder } from 'use-case/analysis/deleteDashboardAnalysis/deleteDashboardAnalysisCriteria';
import { isSome } from 'fp-ts/lib/Option';
import gtmIds from 'adapter/in/dashboards/config/gtm';

const gtm = gtmIds.widget.deleteModal;
export const useOnDeleteDashboardAnalysisModal = (dashboardId: string, analysisId: string) => {
    const { deleteDashboardAnalysis } = useWidget();
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const { data, execute: remove } = useCase(deleteDashboardAnalysis, false);
    const { toggleReloadWidgets } = dispatchWidgetsView();

    const handleOnDelete = () => {
        setShowDeleteModal(true);
    };

    const handleDelete = useCallback(
        () => remove(DeleteDashboardAnalysisCriteriaBuilder.create().withAnalysisId(analysisId).withDashboardId(dashboardId).build()),
        []
    );
    useEffect(() => {
        if (isSome(data)) {
            toggleReloadWidgets(true);
        }
    }, [data]);

    const onDeleteModal = (
        <ConfirmChangesModal
            isOpen={showDeleteModal}
            onClose={() => setShowDeleteModal(false)}
            onProceed={() => {
                handleDelete();
            }}
            message={i18n.t('widgets.delete.warningMsg')}
            title={i18n.t('widgets.actionDelete')}
            proceedButtonText={i18n.t('widgets.delete.yes')}
            proceedButtonVariant='destructive'
            dataIdContext={{
                proceed: gtm.analysisActions.delete,
                cancel: gtm.analysisActions.cancel,
                tryAgain: gtm.analysisActions.tryAgain,
                saveAndProceed: '',
            }}
        />
    );

    return { handleOnDelete, onDeleteModal };
};
